import React from "react";
import Table from "react-bootstrap/Table";
import { formatDate } from "common/FunctionUtils";
import { TransactionHistoryFilter } from "../holiday-pension-filters/TransactionHistoryFilter";

export const HolidayTransactionHistory = ({
  t,
  holidaySavingsData,
  tFilterDate,
  setTFilterDate,
}) => {
  const language = localStorage.getItem("i18nextLng");

  return (
    <>
      <div style={{ marginTop: "25px", marginLeft: "10px" }}>
        <h5> {t("Holiday Transaction History")} </h5>
      </div>
      <TransactionHistoryFilter
        tFilterDate={tFilterDate}
        setTFilterDate={setTFilterDate}
        t={t}
      />

      <div className="w-100 mt-4 table-div">
        <Table striped bordered>
          <thead>
            <tr>
              <th>{t("Id")}</th>
              <th>{t("Invoice No")}</th>
              <th>{t("Amount")}</th>
              <th>{t("Created Date")}</th>
            </tr>
          </thead>
          <tbody>
            {holidaySavingsData?.length ? (
              holidaySavingsData?.map((item) => (
                <tr key={item?.invoiceNumber}>
                  <td>{item?.userId}</td>
                  <td>{item?.invoiceNumber}</td>

                  <td>{item?.holidaySavingsAmount} SEK</td>
                  <td>{formatDate(item?.createdDate, false, language)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4">
                  <h6>{t("No data found")}</h6>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </>
  );
};
